module.exports = __webpack_public_path__ + "img/Logo-NPS@2x.0c999c38.png";